module.exports = __webpack_public_path__ + "static/create-react-app-0db5820c5cd37a9499bafd7ea47386dc.png";